import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AccountResponse} from "../../../../shared/model/response/account-response.model";
import {Menu} from "primeng/menu";
import {MenuItem} from "primeng/api";
import {UserAdminComponentTypeEnum} from "../user-admin-component-type.enum";
import {ModalService} from "../../../../service/modal.service";
import {AccountService} from "../../../../service/api/account.service";
import {take} from "rxjs";
import {MessageToastService} from "../../../../service/message-toast.service";
import {UserStatus} from "../../../../shared/enums/status.enum";

@Component({
    selector: 'app-user-drop-down',
    templateUrl: './user-drop-down.component.html',
    standalone: false
})
export class UserDropDownComponent implements OnInit {

  @Input('user') user: AccountResponse
  @Input({required: true, alias: 'componentType'}) componentType: UserAdminComponentTypeEnum

  @Input('clickEvent')
  set mouseEvent(mouseEvent: MouseEvent) {
    this.initMenu()
    this.menu?.toggle(mouseEvent)
  }

  @Output('onRoleChanceSuccess') onRoleChanceSuccess = new EventEmitter<AccountResponse>()
  @Output('onBlockSuccessEmitter') onBlockSuccessEmitter = new EventEmitter<AccountResponse>()
  @Output('onUnBlockSuccessEmitter') onUnBlockSuccessEmitter = new EventEmitter<AccountResponse>()

  @ViewChild('menu') menu: Menu

  items: MenuItem[] | undefined;

  showuserProfileModal = false
  showPrivilegeModal = false
  showBlockModal = false
  showBlockReason = false;

  constructor(
    private accountService: AccountService,
    private messageService: MessageToastService,
    private modalService: ModalService) {
  }

  ngOnInit(): void {
  }

  initMenu(): void {
    this.items = [
      {
        items: [
          {
            visible: true,
            label: 'Visualizar',
            icon: 'pi pi-eye',
            command: () => this.showuserProfileModal = true
          },
          {
            visible: !this.isBlockedScreen(),
            label: 'Alterar Privilégio',
            icon: 'pi pi-sync',
            command: () => this.showPrivilegeModal = true
          },
          {
            visible: this.isAllScreen() && !this.userIsBlocked(),
            label: 'Bloquear Conta',
            icon: 'pi pi-lock',
            command: () => this.showBlockModal = true
          },
          {
            visible: !this.isPrivilegeScreen() && this.userIsBlocked(),
            label: 'Desbloquear Conta',
            icon: 'pi pi-lock-open',
            command: () => this.onUnblockAccount()
          }, {
            visible: !this.isPrivilegeScreen() && this.userIsBlocked(),
            label: 'Motivo do Bloqueio',
            icon: 'pi pi-file-excel',
            command: () => this.showBlockReason = true
          }
        ]
      }
    ];
  }

  userIsBlocked(){
    return this.user.status?.code === UserStatus.BLOCKED
  }

  isPrivilegeScreen() {
    return this.componentType === UserAdminComponentTypeEnum.PRIVILEGE
  }

  isBlockedScreen() {
    return this.componentType === UserAdminComponentTypeEnum.BLOCKED
  }

  isAllScreen() {
    return this.componentType === UserAdminComponentTypeEnum.ALL
  }


  onRoleChangeSuccess($event: AccountResponse) {
    this.onRoleChanceSuccess.emit($event)
  }

  onBlockSuccess($event: AccountResponse) {
    this.onBlockSuccessEmitter.emit($event)
  }


  private onUnblockAccount() {

    const fullName = this.user.firstname.concat(" ", this.user.lastname)

    this.modalService.simpleConfirmation({
      title: "Desbloquar Conta",
      message: "Tem certeza que deseja Desbloquear o Utilizador " + fullName
    })
      .then(confirmed => {
        if (!confirmed) {
          return
        }
        this.accountService.unblock(this.user.id).pipe(take(1)).subscribe({
        next: (value) => {
          this.messageService.success(value.message)
          this.onUnBlockSuccessEmitter.emit(value.data)
        },
        error: error => this.messageService.error(error.message)
      })
      })
  }

}
